// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import 'lib-flexible'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(VueCookies)
Vue.$cookies.config('7d')

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

/* vuex 全局单例 */
const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  plugins: [vuexLocal.plugin]
})

// 全局守卫，如果没有token则导航到登陆页面
router.beforeEach((to, from, next) => {
  let isExitToken = Vue.$cookies.isKey('token')
  if (isExitToken) {
    if (to.name === 'login') {
      next({name: 'stepone'})
    } else {
      next()
    }
  } else {
    if (to.name !== 'login') {
      next({name: 'login'})
    } else {
      next()
    }
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js